module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-flex flex-column align-items-start py-2 px-4"
  }, [_c('h3', {
    staticClass: "font-weight-bold"
  }, [_vm._v("Recuperar Contraseña")]), _vm._v(" "), _c('p', [_vm._v("Ingresa el correo electrónico asociado a tu cuenta")]), _vm._v(" "), _c('div', {
    staticClass: "form-group w-100"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": "getEmail"
    }
  }, [_vm._v("Correo electrónico")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "id": "getEmail",
      "aria-describedby": "getEmail",
      "placeholder": "Ingresa tu email"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-primary mt-4 btn-lg btn-block",
    attrs: {
      "to": "/correctpass"
    }
  }, [_vm._v("Continuar")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1b63e9ec"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/NewPassword.vue
// module id = 1855
// module chunks = 1